<template>
    <SuccessStoriesListDefault v-if="slice.variation === 'default'" :slice="slice" />
    <SuccessStoriesListSelection v-else :slice="slice" />
</template>

<script setup lang="ts">
    import {getSliceComponentProps} from '@prismicio/vue';
    import type {SuccessStoriesListSlice} from '@prismicio-types';

    import SuccessStoriesListDefault from './SuccessStoriesListDefault.vue';
    import SuccessStoriesListSelection from './SuccessStoriesListSelection.vue';

    defineProps({
        ...getSliceComponentProps<SuccessStoriesListSlice>(),
    });
</script>
